import React from 'react';
import ScrollMagie from '../../helpers/scrollmagie'

export default class detail extends React.Component {

    componentDidMount() {
        $("html, body").animate({scrollTop: 0}, 0);
        new ScrollMagie()
    }

    render() {
        return <section>


            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/storytelling/cover@2x.jpg)"}}>
                <div className="scroll-down-wrapper">
                    <div className="scroll-down">
                        <p>Scroll<br/>down</p>
                        <img src="public/images/scroll.svg" alt=""/>
                    </div>
                </div>
            </div>

            <div className="section-wrapper">
                <div className="container">
                    <div className="row relative">
                        <div className="gr-5 no-gutter">
                            <div className="image text-right transform-l-30"
                                 style={{
                                     position: "relative",
                                     zIndex: 1,
                                     marginTop: "-3vw"
                                 }}>
                                <div className="animate" data-transform-y="-10%" data-transform-duration="100%">
                                    <img src="public/images/storytelling/20160519-JK2_6695.jpg" alt=""
                                         className="image-resp"/>
                                </div>
                            </div>
                        </div>
                        <div className="gr-7 no-gutter">
                            <div style={{
                                position: "relative",
                                zIndex: 2,
                            }}>
                                <div className="animate" data-transform-y="10%" data-transform-duration="100%">
                                    <img src="public/images/storytelling/collage_1_2.jpg" alt=""
                                         className="image-resp"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="gr-2">&nbsp;</div>
                        <div className="gr-4"
                             style={{
                                 position: "relative",
                                 zIndex: 3,
                                 marginTop: "-5vw"
                             }}>
                            <div className="animate" data-transform-y="-10%" data-transform-duration="100%">
                                <img src="public/images/storytelling/collage_1_1.jpg" alt=""
                                     className="image-resp"/>
                            </div>
                        </div>
                        <div className="gr-6">
                            <div className="padding-dynamic-left-3 padding-dynamic-top-2">
                                <div className="animate" data-transform-y="10%" data-transform-duration="100%">
                                    <h1>STORY<br/>TELLING</h1>
                                    <div className="width-percent-70">
                                        <p >
                                            Geschichten erzählen in Form von starken Bildkonzepten.
                                            Dabei ist der Kern immer der Inhalt, und der Kern des guten Inhalts ist eine
                                            gute Geschichte. Diese gilt es zu finden, auf das Wesentliche zu verdichten
                                            und
                                            durch eine visuelle Umsetzung erfahrbar zu machen. Nicht alle Bilder
                                            brauchen
                                            eine Geschichte. Aber diejenigen die eine haben, berühren den Betrachter
                                            tiefer
                                            und bleiben ihm somit länger im Gedächtnis und dabei ist es egal ob es sich
                                            um
                                            eine Motorsportveranstaltung oder einen kreativen Saunawettbewerb handelt.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/storytelling/full_1@2x.jpg)"}}></div >
            <div className="section-wrapper" style={{paddingTop: 0}}>
                <div style={{padding: "0vw 10vw"}}>
                    <div className="row">
                        <div className="gr-1">&nbsp;</div>
                        <div className="gr-5">
                            <div className="image" style={{transform: "translate(0px, 8vw)", paddingBottom: "5vw"}}>
                                <div className="animate" data-transform-y="-5%" data-transform-duration="100%">
                                    <img src="public/images/storytelling/collage_2_1@2x.jpg" alt=""
                                         className="image-resp"
                                         style={{width: "100%"}}/>
                                </div>
                            </div>
                        </div>
                        <div className="gr-1">&nbsp;</div>
                        <div className="gr-5">
                            <div className="image" style={{transform: "translate(0px, -9vw)", paddingBottom: "-5vw"}}>
                                <div className="animate" data-transform-y="10%" data-transform-duration="100%">
                                    <img src="public/images/storytelling/collage_2_2@2x.jpg" alt=""
                                         className="image-resp"
                                         style={{width: "100%"}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="section-wrapper" style={{marginTop: "-380px"}}>
                <div className="row">
                    <div className="gr-4 no-gutter">
                        &nbsp;
                    </div>
                    <div className="gr-3 no-gutter">
                        &nbsp;
                    </div>
                    <div className="gr-5 no-gutter">
                        <h1>EDITORIAL WORK</h1>
                        <div className="width-percent-70">

                        </div>
                    </div>
                    <div className="gr-2 no-gutter">
                        <div className="image">
                            <img src="public/images/storytelling/collage_3_1@2x.jpg" alt="" className="image-resp"
                                 style={{width: "100%"}}/>
                        </div>
                    </div>
                    <div className="gr-2 no-gutter"
                         style={{zIndex: 2, transform: "scale(1.1) translate(0px, 10vw)", paddingBottom: "10vw"}}>
                        <div className="image">
                            <img src="public/images/storytelling/collage_3_2@2x.jpg" alt="" className="image-resp"
                                 style={{width: "100%"}}/>
                        </div>
                    </div>
                    <div className="gr-2 no-gutter">
                        <div className="image"
                             style={{transform: "scale(1.1) translate(0px,-5vw)", paddingBottom: "-5vw"}}>
                            <img src="public/images/storytelling/collage_3_3@2x.jpg" alt="" className="image-resp"
                                 style={{width: "100%"}}/>
                        </div>
                    </div>
                    <div className="gr-2 no-gutter">
                        <div className="image"
                             style={{zIndex: 1, transform: "scale(1.9) translate(0px, 15vw)", paddingBottom: "15vw"}}>
                            <img src="public/images/storytelling/collage_3_4@2x.jpg" alt="" className="image-resp"
                                 style={{width: "100%"}}/>
                        </div>

                    </div>
                    <div className="gr-4 no-gutter">
                        <div className="image"
                             style={{transform: "scale(1.1) translate(0px, 10vw)", paddingBottom: "10vw"}}>
                            <img src="public/images/storytelling/collage_3_5@2x.jpg" alt="" className="image-resp"
                                 style={{width: "100%"}}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="section-wrapper" style={{paddingTop: 0}}>

                <div className="image text-center" style={{position: "relative", zIndex: 2,}}>
                    <img src="public/images/storytelling/collage_4_1@2x.jpg" alt="" className="image-resp"
                         style={{width: "70vw"}}/>
                </div>


                <div className="row">
                    <div className="gr-6"
                         style={{position: "relative", zIndex: 0, transform: "translate(0px, 15vw)"}}>
                        <div className="image transform-r-0">
                            <div className="animate" data-transform-y="30%" data-transform-duration="100%">
                                <img src="public/images/storytelling/collage_4_2@2x.jpg" alt="" className="image-resp"/>
                            </div>
                        </div>
                    </div>

                    <div className="gr-6">
                        <div className="image transform-l-0" style={{position: "relative", zIndex: 2,}}>
                            <img src="public/images/storytelling/collage_4_3@2x.jpg" alt=""
                                 style={{width: "92%", float: "right", transform: "translate(0px, -5vw)"}}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="fullscreen-image"
                 style={{backgroundImage: "url(public/images/storytelling/full_2@2x.jpg)"}}></div >

            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/storytelling/with_text@2x.jpg)"}}></div >


            <img src="public/images/storytelling/grid2_2500px.jpg" alt="" className="pull-left"
                 style={{width: "100%"}}/>
            <div className="clearfix"></div>

            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/storytelling/full_3@2x.jpg)"}}></div >

            <div className="next animate">
                <div className="row">
                    <div className="gr-12">
                        <a href="#/categories/people">
                            <h1>NEXT</h1>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    }
}



// WEBPACK FOOTER //
// ./src/scripts/pages/categories/storytelling.jsx